<template>
  <div class="container prepage flex all-c">
  </div>
</template>
<script>
// import { Dialog } from 'vant';

export default {
  name: 'pre-page',
  components: {
  },
  data() {
    return {
      // todo
    };
  },
  computed: {
    // todo
  },
  watch: {},
  beforeMount() {
    // todo
  },
  mounted() {
    // todo
  },
  methods: {
    // todo
  }
};
</script>
<style lang="less" scoped>
  .prepage{height:100vh;}
  /*.scan-qr{ padding: 100px 0 0 0;}*/
  .scan-qr .img-auto{ width: 73px; height: 73px; margin:0 auto 25px;}
</style>
